var map = {
	"./belmont.png": 6461,
	"./bestiole.gif": 80,
	"./bestiole_light_short.png": 8189,
	"./fossil-pollen-percentage.png": 2512,
	"./graph-plot.png": 7460,
	"./img1.png": 1586,
	"./img2.png": 5593,
	"./ipsl.png": 5382,
	"./locean.png": 306,
	"./logo.png": 3153,
	"./map-plot.png": 5534,
	"./spreadsheet-plot.png": 8838
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;